import { render, staticRenderFns } from "./ITRemittence.vue?vue&type=template&id=2ad55018&scoped=true&lang=html"
import script from "./ITRemittence.vue?vue&type=script&lang=js"
export * from "./ITRemittence.vue?vue&type=script&lang=js"
import style0 from "./ITRemittence.vue?vue&type=style&index=0&id=2ad55018&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad55018",
  null
  
)

export default component.exports